<template>
  <div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
      >
        <el-table-column property="sendTimeShow" label="时间"/>
        <el-table-column property="" label="内容">
          <template #default="scope">
<!--            <div v-if="scope.row.contentType == 1">-->
              <p>{{ scope.row.content }}</p>
              <p style="color: red">{{ scope.row.fixContent }}</p>
<!--            </div>-->
<!--            <div v-if="scope.row.contentType == 2"> <el-image style="width: 80px; height: 80px" :src="scope.row.url" @click="showImg(scope.row.url)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image> </div>-->
<!--            <div v-if="scope.row.contentType == 3">-->
<!--              <audio :ref="'audio' + scope.$index" controls :src="scope.row.url" type="audio/mpeg" @play="pauseOther(scope.$index)">您的浏览器不支持该音频格式。</audio>-->
<!--            </div>-->
          </template>
        </el-table-column>
            <el-table-column property="" label="图片">
              <template #default="scope">
                <el-image v-if="scope.row.imgUrl" style="width: 80px; height: 80px" :src="scope.row.imgUrl" @click="showImg(scope.row.imgUrl)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </template>
            </el-table-column>
<!--        <el-table-column property="content" label="是否已发送">-->
<!--          <template #default="scope">-->
<!--            {{scope.row.isSend == 1?'已发送':scope.row.isSend == 2?'本平台拦截':scope.row.isSend == 3?'融云拦截':''}}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column property="" label="违规描述">
          <template #default="scope">
            <p>{{ scope.row.sendState == 1?'已发送':scope.row.sendState == 2?'本平台拦截':scope.row.sendState == 3?'融云拦截':scope.row.sendState == 4?'屏蔽拦截':''}}</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getAbnormalChatList } from '@/api/url'
import { getFormData } from '@/api/api'
import ImgViewer from '../../../../assets/js/imageViewer'

export default {
  name: "InviteDetailDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.userId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAbnormalChatList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(url) {
      let imgList = []
      imgList.push(url)
      ImgViewer.open({
        imgList
      })
    },

    //语音
    pauseOther(index) {
      let audioDom= this.$refs['audio'+ index]
      audioDom.play();
      const audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
        if(i !== audioDom) {
          i.pause();
          i.currentTime = 0;
        }
      })
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
